import { render, staticRenderFns } from "./JThirdAppDropdown.vue?vue&type=template&id=06b66b73&scoped=true&"
import script from "./JThirdAppDropdown.vue?vue&type=script&lang=js&"
export * from "./JThirdAppDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b66b73",
  null
  
)

export default component.exports